import {HttpExclude, Request, RequestExpose} from '@simpli/serialized-request'
import {ExpansibleCollection} from '@simpli/resource-collection'
import {OrbitTransactionGroupSummary} from '@/model/resource/OrbitTransactionGroupSummary'
import {OrbitTransactionGroupedItem} from '@/model/resource/OrbitTransactionGroupedItem'

@HttpExclude()
export class OrbitTransactionGroupSummaryCollection extends ExpansibleCollection<
  OrbitTransactionGroupSummary
> {
  constructor() {
    super(OrbitTransactionGroupSummary)
  }

  @RequestExpose() limit: number | null = null
  @RequestExpose() round: number | null = null
  @RequestExpose() address: string | null = null
  @RequestExpose() eventname: string | null = null
  @RequestExpose() hash: string | null = null
  @RequestExpose() idOrbitRoundFk: number | null = null
  /** blockchain_version.networkIdentifier: 'neo3/mainnet' | 'neo3/testnet' */
  @RequestExpose() networkIdentifier: string | null = null

  queryAsPage() {
    return this.listOrbitTransactionGrouped()
  }

  async listOrbitTransactionGrouped() {
    return await Request.get(`/client/orbit-transaction/grouped`, {
      params: this.params,
    })
      .name('listOrbitTransactionGrouped')
      .as(this)
      .getResponse()
  }

  async listOrbitTransactionGroupedItems(): Promise<
    OrbitTransactionGroupedItem[]
  > {
    const raw = await Request.get(`/client/orbit-transaction/grouped/items`, {
      params: this.params,
    })
      .name('listOrbitTransactionGroupedItems')
      .asAny()
      .getData()

    return (raw || []).map(
      (item: Record<string, unknown>) =>
        Object.assign(
          new OrbitTransactionGroupedItem(),
          item
        ) as OrbitTransactionGroupedItem
    )
  }
}
